import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo, CampoNumero, CampoCheckBox, CampoGaranzia } from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';

interface IGaranzieSelezionabileProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON
    Abilitato?: boolean;
    OnChangeElement?: (valore: any) => void;
}

export class CampoGaranzie extends BasePureComponent<IGaranzieSelezionabileProps> {

    private _Garanzie: DatiRCP.CCampoGaranzia[] = [];
    private _Abilitato: boolean = true;

    public constructor(props: any) {
        super(props);

        this.OnChangeGaranzie = this.OnChangeGaranzie.bind(this);
    }

    private Inizializza(props: IGaranzieSelezionabileProps) {
        this._Abilitato = props.Abilitato != undefined ? props.Abilitato : true;
        this.PopolaValori(props.Value);
    }

    private PopolaValori(valore: string) {
        this._Garanzie = [];
        //console.warn("PopolaValori", valore);
        if (valore != undefined && valore != "") {
            try {
                if (typeof (valore) == "string") {
                    this._Garanzie = JSON.parse(valore);
                } else {
                    this._Garanzie = valore;
                }
            } catch (Error) {
                //console.warn("ERRORE", Error.message, valore);
                this._Garanzie = [];
            }
        } else {
            this._Garanzie = [];
        }
    }

    private GetGaranzie(): any {
        let garanzie: any[] = [];

        let riga: any[] = [];

        for (let i: number = 0; i < this._Garanzie.length; i++) {
            if (i % 4 == 0) { //ogni 4 garanzie metto una riga nuova
                garanzie.push(<div className="row" key={i}>{riga}</div>);
                riga = [];
            }

            riga.push(<CampoGaranzia key={i} Name={this._Garanzie[i].ID_TipoGaranzia}
                Id={this._Garanzie[i].ID_TipoGaranzia}
                Value={JSON.stringify(this._Garanzie[i])}
                OnChange={this.OnChangeGaranzie} />);
        }
        garanzie.push(<div className="row" key={this._Garanzie.length + 1}>{riga}</div>);
        return garanzie;
    }

    private OnChangeGaranzie(e: React.FormEvent<any> | string, valore?: any): void {
        if (this._Abilitato) {
            let garanzia: DatiRCP.CCampoGaranzia = JSON.parse(valore);
            for (let i: number = 0; i < this._Garanzie.length; i++) {
                if (this._Garanzie[i].ID_TipoGaranzia == garanzia.ID_TipoGaranzia)
                    this._Garanzie[i] = garanzia;
            }

            this.props.OnChange(this.props.Name, JSON.stringify(this._Garanzie));   
            if (this.props.OnChangeElement) {
                this.props.OnChangeElement(valore);
            }
        }
    }

    public render() {
        this.Inizializza(this.props);

        return <div className="tab-content kt-padding-30">
            {this.GetGaranzie()}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoGaranzie.tsx